import { render } from "./ItemBox.vue?vue&type=template&id=18ed3217"
import script from "./ItemBox.vue?vue&type=script&lang=js"
export * from "./ItemBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__